import { FC } from 'react';

import { Card, Text } from '@hh.ru/magritte-ui';
import { IconWrapperComponentSize24 } from '@hh.ru/magritte-ui-icon';
import { Link as SPALink } from '@hh.ru/redux-spa-middleware';

import styles from 'components/Header/HeaderUserDrop/UserDropButton/UserDropButton.module.less';

interface UserDropButtonProps {
    dataQa: string;
    text: string;
    Icon: IconWrapperComponentSize24;
    to?: string;
    onClick?: () => void;
}

export const UserDropButton: FC<UserDropButtonProps> = ({ dataQa, text, Icon, to, onClick }) => {
    return (
        <Card
            Element={to ? SPALink : undefined}
            padding={12}
            borderRadius={12}
            hoverEnabled
            hoverStyle="secondary"
            increaseShadow={false}
            stretched
            data-qa={dataQa}
            to={to || ''}
            onClick={onClick}
        >
            <div className={styles.wrapper}>
                <Icon padding={12} borderRadius={16} initialColor="secondary" backgroundStyle="secondary" />
                <Text>{text}</Text>
            </div>
        </Card>
    );
};
